import React, { useState } from "react";
import { Route, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useEffect } from "react";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { useLocation, BrowserRouter as Router } from "react-router-dom";
import { useTranslation } from "react-i18next";
import lock from "../Assets/images/secure-lock-icon.png";
import FraudArmor from "../Assets/images/FraudArmor.png";
import parse from "html-react-parser";

import { DialogComponent } from "../../components/common/DialogComponent";
import PSSPopupDetails from "../../components/Dialogs/PSSPopupDetails";

interface IDefaultProps {
    component: any;
    path?: string;
    exact?: boolean;
}
let isRedirect = true;
const PSSPageHeader: React.SFC<IDefaultProps> = (props) => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const RetailerCode: any = query.get("RetailerCode") || query.get("RETAILERCODE");
    const LookupValue: any = query.get("VALUE");
    const LookupType: any = query.get("Type");
    const redirectToken = query.get("Redirect") || query.get("REDIRECT") || query.get("redirect");
    const { component: Component, ...rest } = props;
    const dispatch = useDispatch();
    const history: any = useHistory();
    const requesPartnerConfig = () => dispatch(ConfigurationActions.actionCreators.requestPartnerConfig(RetailerCode, LookupType, LookupValue));
    const partnerDisplayName: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    const loggedInActiveAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount ? state.loggedInUser.activeAccount : null
    );
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const fromLogout = history && history.location.state ? history.location.state.from : "";
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    // const [language, setLanguage] = React.useState('');
    // const [language, setLanguage] = React.useState(document.cookie.split(';').filter((cookieElement: string) => cookieElement.split('=')[0].trim() == 'user_prefered_language').length > 0 ? !!document.cookie.split(';').filter((cookieElement: string) => cookieElement.split('=')[0].trim() == 'user_prefered_language')[0].split('=')[1] ? document.cookie.split(';').filter((cookieElement: string) => cookieElement.split('=')[0].trim() == 'user_prefered_language')[0].split('=')[1] : 'en' : 'en')
    const { t: tLang, i18n: i18nLang } = useTranslation();

    let currentPathLoc = useLocation();
    var currentPath = currentPathLoc.pathname.slice(13);

    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    let language =
        !!partnerLanguageOptions && partnerLanguageOptions.length > 1
            ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                ? !!document.cookie
                    .split(";")
                    .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                    .split("=")[1]
                    ? document.cookie
                        .split(";")
                        .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                        .split("=")[1]
                    : "en"
                : "en"
            : "en";
    const isMetLifePartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2573
                ? true
                : false
            : false
    );
    let partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );

    function get_cookie(name: string) {
        return document.cookie.split(";").some((c) => {
            return c.trim().startsWith(name + "=");
        });
    }

    useEffect(() => {
        i18nLang.changeLanguage(!!partnerLanguageOptions && partnerLanguageOptions.length > 1 ? language : "en");
    }, [fromLogout || language]);
    function delete_cookie(name: string) {
        if (get_cookie(name)) {
            document.cookie = name + "=" + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
        }
    }
    const setUserPreferedLanguage = (language: string) => {
        delete_cookie("user_prefered_language");
        document.cookie = "user_prefered_language=" + language;
        i18nLang.changeLanguage(language);
        language = language;
        const toggleUser: any = document.querySelector("#user-profile-btn");
        const userMenu: any = document.querySelector("#user-profile");
        userMenu.classList.remove("is-active");
        toggleUser.setAttribute("aria-expanded", false);
    };

    const toggleLanguageSelectionWidget = () => {
        const toggleUser: any = document.querySelector("#user-profile-btn");
        const userMenu: any = document.querySelector("#user-profile");
        userMenu.classList.add("is-active");
        toggleUser.setAttribute("aria-expanded", true);
    };

    const brandingOptions = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath) {
            return {
                imagePath: state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath,
                secondaryLogo: state.configurationState.configuration?.partnerConfig?.brandingOption?.secondaryLogo,
                associationText: state.configurationState.configuration?.partnerConfig?.brandingOption?.associationText,
                secondaryText: state.configurationState.configuration?.partnerConfig?.brandingOption?.secondaryText,
                originalSiteUrl: state.configurationState.configuration?.partnerConfig?.originSiteUrl,
            };
        } else {
            return {
                imagePath: "",
                associationText: "",
                secondaryText: "",
                originalSiteUrl: "",
            };
        }
    });

    useEffect(() => {
        if (!fromLogout) {
            requesPartnerConfig();
            if (redirectToken && isRedirect) {
                isRedirect = false;
                dispatch(ConfigurationActions.actionCreators.getRedirectTokenAction(redirectToken.replace(/"/g, "")));
            }
        }
    }, []);

    const overlayClose = () => { };
    const dataLayer = () => { };

    const [showAlertDetails, setShowAlertDetails] = useState(false);

    const handleShow = () => {
        setShowAlertDetails(true);
    };

    const handleCloseDialog = (): any => {
        setShowAlertDetails(false);
    };
    const [pathLocation, setPathLocation] = useState("");
    useEffect(() => {
        currentPath = currentPath.replace("/", " | ");
        currentPath = currentPath.split("-").join(" ");
        currentPath = currentPath.replace(/(?:^|\s)\S/g, (res) => {
            return res.toUpperCase();
        });
        setPathLocation(currentPath);
    }, [partnerDisplayName, currentPathLoc]);

    return (
        <Route
            {...rest}
            render={(matchProps) => (
                <React.Fragment>
                    <header className={pathLocation == "PssSisk" ? "pss6top-header" : pathLocation == "StartProtection" ? "start-protection pssheader" : "pssheader"}>
                        <a className="skip-main" href="#content">
                            {tLang("skipToMainContent.label")}
                        </a>

                        <div className="row l-page-container">
                            {pathLocation == "PssSisk" ? (
                                <div className="pss6-header-container">
                                    <table style={{ width: "100%", padding: "0px", marginTop: "10px" }}>
                                        <tbody>
                                            <tr>
                                                {Boolean(brandingOptions?.imagePath) && (
                                                    <td className="pss-left-header">
                                                        <div className="flex-grow-null">
                                                            <div className="middle-xs" style={{ display: "flex", justifyContent: "center" }}>
                                                                <a href={decodeURIComponent(encodeURIComponent(window.location.href))} className="main-logo-link" role="option">
                                                                    <div
                                                                        className="main-logo js-partnerLogo"
                                                                        style={{ display: "flex", opacity: 100, position: "relative", top: "0px", left: "0px" }}
                                                                    >
                                                                        <img src={brandingOptions?.imagePath} alt="Logo" className="logoImg pss5logo" style={{ width: "208px" }} />
                                                                    </div>
                                                                </a>
                                                                <div className="pss6-js-partnerAssociation">
                                                                    <div className="pss6-associationText">{parse(brandingOptions?.associationText || "", {})}</div>
                                                                    <div className="pss6-secondaryText">{parse(brandingOptions?.secondaryText || "", {})}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                )}
                                                <td style={{ float: "right" }}>
                                                    <div className="pss6-topRightContent pss-hide-mobile">
                                                        <ul className="top_links fr cr">
                                                            <li className="reportFraud">
                                                                <div className="outerTabContainer">
                                                                    <a href="https://sisk.identityforce.com/ReportFraud/tabid/122/Default.aspx">
                                                                        <span className="innerTabContainer">Report Fraud</span>
                                                                    </a>
                                                                    &nbsp;&nbsp;|&nbsp;&nbsp;
                                                                </div>
                                                            </li>
                                                            <li className="secureLogin">
                                                                <div className="outerTabContainer">
                                                                    <a href="/app/login">
                                                                        <span className="innerTabContainer" style={{ color: "#E51E10" }}>
                                                                            Secure Login
                                                                        </span>
                                                                    </a>
                                                                </div>
                                                            </li>
                                                        </ul>

                                                        <div>
                                                            <a className="pss6-international-phone" href={'tel:"' + partnerPhoneNumber + '"'}>
                                                                {partnerPhoneNumber}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ) : pathLocation == "FraudArmor" ? (
                                <table style={{ width: "100%", padding: "0px", marginTop: "10px" }}>
                                    <tbody>
                                        <tr>
                                            <td className="pss-left-header">
                                                <div className="flex-grow-null">
                                                    <div className=" middle-xs">
                                                            <a href={decodeURIComponent(encodeURIComponent(window.location.href))} className="main-logo-link" role="option">
                                                            <div
                                                                className="main-logo js-partnerLogo"
                                                                style={{ opacity: 100, position: "relative", top: "0px", left: "0px" }}
                                                            >
                                                                <img src={FraudArmor} alt="Logo" className="logoImg pss5logo" style={{ width: "300px" }} />
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ float: "right" }}>
                                                <div className="fraud-armour-topRightContent pss-hide-mobile">
                                                    <ul className="top_links fr cr">
                                                        <li className="contactUsLink">
                                                            <div className="outerTabContainer">
                                                                <a href="https://www.fraudarmorservice.com/WhyUs/ContactUs/tabid/116/Default.aspx">
                                                                    <span className="innerTabContainer">Contact Us</span>
                                                                </a>
                                                                &nbsp;|&nbsp;&nbsp;
                                                            </div>
                                                        </li>
                                                        <li className="reportFraud">
                                                            <div className="outerTabContainer">
                                                                <a href="https://www.fraudarmorservice.com/ReportFraud/tabid/122/Default.aspx">
                                                                    <span className="innerTabContainer">Report Fraud</span>
                                                                </a>
                                                                &nbsp;&nbsp;|&nbsp;&nbsp;
                                                            </div>
                                                        </li>
                                                        <li className="secureLogin">
                                                            <div className="outerTabContainer">
                                                                <a href="/app/login">
                                                                    <span className="innerTabContainer">Secure Login</span>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                    <div className="fraud-armor-phone-container cr fr test">
                                                        <div className="fraud-armor-phone-container ">
                                                            <h1 className="inline">
                                                                <span className="international-phone"></span>
                                                                <a href="tel:866-923-0452">866-923-0452 </a>
                                                            </h1>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            ) : (
                                <table style={{ width: "100%", padding: "0px" }}>
                                    <tbody>
                                        <tr>
                                            <td className="pss-left-header">
                                                <div className="col-xs flex-grow-null">
                                                    <div className=" middle-xs">
                                                        <div className="col-no-gutter">
                                                                    {Boolean(brandingOptions?.imagePath) ? (

                                                                        pathLocation == "CommerceBank" ? (
                                                                            <div className="logo-container pss9-logo-container"
                                                                            >
                                                                                <a
                                                                                    href={decodeURIComponent(encodeURIComponent(window.location.href))}
                                                                                    onClick={(e) => e.preventDefault()}
                                                                                    title="Go to Homepage"
                                                                                    className="logo-link" role="option"
                                                                                >
                                                                                    <div className="pss-partner-title">{parse(brandingOptions?.secondaryText || "", {})}</div>
                                                                                    <img
                                                                                        src={brandingOptions?.imagePath}
                                                                                        alt={"Logo"}
                                                                                    />
                                                                                </a>


                                                                            </div>
                                                                        )
                                                                            : pathLocation == "Aflac" || pathLocation == "AflacRegister"  ? (

                                                                            <div className="logo-container pss8-logo-container">
                                                                                <div>

                                                                                    <a
                                                                                        href={decodeURIComponent(encodeURIComponent(window.location.href))}
                                                                                        title="Go to Homepage"
                                                                                        className="pss8-logo-link" role="option"
                                                                                    >
                                                                                        <div className="logo-partner">
                                                                                                <div className="pss8-partner-title">{parse(brandingOptions?.associationText || "", {})}</div>
                                                                                                <div className="pss8-partner-title">{parse(brandingOptions?.secondaryText || "", {})}</div>
                                                                                        </div>
                                                                                        <img
                                                                                            src={brandingOptions?.imagePath}
                                                                                            alt={"Logo"}
                                                                                        />
                                                                                    </a>
                                                                                </div>

                                                                            </div> ) 
                                                                                    :
                                                                            (
                                                                                <div className="logo-container pss-logo-container" >
                                                                                    <a
                                                                                        href={decodeURIComponent(encodeURIComponent(window.location.href))}
                                                                                        title="Go to Homepage"
                                                                                        className="logo-link" role="option"
                                                                                    >
                                                                                        <img
                                                                                            src={brandingOptions?.imagePath}
                                                                                            alt={"Logo"}
                                                                                        />
                                                                                    </a>
                                                                                </div>
                                                                            )) :
                                                                <></>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ float: "right" }}>
                                                {pathLocation === "StartProtection" ? (
                                                    <div className="col-xs flex-grow-null">
                                                        <div className="user-container pss-hide-mobile">
                                                            <div className="m-pop-under">
                                                                <div className="startprotection-help-text">
                                                                    Already enrolled?<a href="/app/login">Login Now</a>
                                                                </div>
                                                                <div className="phone_container" style={{ float: "right" }}>
                                                                    <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="col-xs flex-grow-null pss-hide-mobile">
                                                        <div className="security-statement-container" onClick={() => handleShow()}>
                                                            <img src={lock} alt="" />
                                                            <a className="pss-security_statement btn btn-small btn-outline" href="javascript:void(0);">
                                                                Learn how we secure your data with Triple Layer Defense™
                                                            </a>
                                                        </div>
                                                        <div className="user-container pss-account-login">
                                                            <div className="m-pop-under">
                                                                            <div className={pathLocation === "ProvisionalResponseLandingPage1" || pathLocation === "ProvisionalResponseLandingPage2" ? "help_text1" : "help_text"}>
                                                                                Already have an account? <a href="/app/login">Log In</a>
                                                                </div>
                                                                            <div className={pathLocation === "ProvisionalResponseLandingPage1" || pathLocation === "ProvisionalResponseLandingPage2" ? "pss1_phone_container" : pathLocation === "Aflac" || pathLocation === "AflacRegister" ? "pss7_phone_container" : "phone_container"}>
                                                                <a href={'tel:"' + partnerPhoneNumber + '"'}>
                                                                    {partnerPhoneNumber}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                )}
                                        </td>
                                    </tr>
                                </tbody>
                                </table>
                            )}
                    </div>
                </header>
                    {showAlertDetails && (
                <div className="pss-dialog-container">
                    <DialogComponent dialogId="alert-details-dialog" title="Alert Details" closeDialog={handleCloseDialog}>
                        <PSSPopupDetails />
                    </DialogComponent>
                </div>
            )}
                </React.Fragment >
            )}
/>
    );
};

export default PSSPageHeader;
